import { parse, format, addMonth } from "ts-date/esm/locale/en";
export class DateUtils {
	public static CompareDate(d1: Date, d2: Date): boolean {
		d1.setHours(0, 0, 0, 0);
		d2.setHours(0, 0, 0, 0);
		return d1.getTime() === d2.getTime();
	}
	public static FormatDate(d: Date, template: string): string {
		return format(d, template) as string;
	}
}
